import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    // mode: 'history',
    routes: [
        // 默认路由
        {
            path: '/',
            redirect: '/home',
            meta: {
                //是否需要登录
                requiresAuth: false,
                //是否保留顶部导航栏
                keepAlive: true,

            }
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/home/Home.vue'),
            meta: {
                requiresAuth: false,
                keepAlive: true,
                //顶部导航栏是否透明
                transparent: false,
            }
        },
        {
            path: '/news',
            name: 'news',
            component: () => import('@/views/news/NewsList.vue'),
            meta: {
                requiresAuth: false,
                keepAlive: true,
                //顶部导航栏是否透明
                transparent: false,
            }
        },
        {
            path: '/newDetail',
            name: 'newDetail',
            component: () => import('@/views/news/Detail.vue'),
            meta: {
                requiresAuth: false,
                keepAlive: true,
                //顶部导航栏是否透明
                transparent: false,
            }
        },
        {
            path: '/services',
            name: 'services',
            component: () => import('@/views/service/Index.vue'),
            meta: {
                requiresAuth: false,
                keepAlive: true,
                //顶部导航栏是否透明
                transparent: false,
            }
        },
        {
            path: '/guides',
            name: 'guides',
            component: () => import('@/views/guides/Index.vue'),
            meta: {
                requiresAuth: false,
                keepAlive: true,
                //顶部导航栏是否透明
                transparent: false,
            }
        },
        {
            path: '/guideDetail',
            name: 'guideDetail',
            component: () => import('@/views/guides/Detail.vue'),
            meta: {
                requiresAuth: false,
                keepAlive: true,
                //顶部导航栏是否透明
                transparent: false,
            }
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('@/views/about/Index.vue'),
            meta: {
                requiresAuth: false,
                keepAlive: true,
                //顶部导航栏是否透明
                transparent: false,
            }
        },
        {
            path: '/downloadApp',
            name: 'downloadApp',
            component: () => import('@/views/downloadApp/Index.vue'),
            meta: {
                requiresAuth: false,
                keepAlive: true,
                //顶部导航栏是否透明
                transparent: false,
            }
        },
    ]
})

// 路由跳转前
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        next()
    } else {
        next() // 确保一定要调用 next()
    }
})

// 路由跳转后
router.afterEach((to, from) => {
    window.scrollTo(0, 0) // 每次路由改变滚动条都回到顶部
})

export default router
